import { Component, Input } from '@angular/core';
import { Road } from 'src/app/modules/route-planner/models/route-signposts-model';

@Component({
    selector: 'aa-signpost',
    templateUrl: './aa-signpost.component.html',
    styleUrls: ['./aa-signpost.component.scss'],
    standalone: false
})
export class AaSignpostComponent {

  @Input() road: Array<Road>;

  constructor() { }

  get roads() {
    return this.road;
  }

  trackByFn(index: number): number {
    return index;
  }
}
